import { FETCH_APILOGS, FETCH_APILOGS_IS_ERROR, FETCH_APILOGS_IS_PENDING, FILTER_APILOGS } from 'services/Account/APILogs/types';

const INITIAL_STATE = {
  logs: [],
  filterBy: 'ALL',

  fetchApiLogsIsCompleted: false,
  fetchApiLogsIsPending: false,
  fetchApiLogsIsError: null,
};

const apiLogsReducer = (
  state = {
    ...INITIAL_STATE,
  },
  action = undefined,
) => {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  switch (action.type) {
    case FETCH_APILOGS:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        logs: action.logs,
        fetchApiLogsIsCompleted: true,
        fetchApiLogsIsPending: false,
        fetchApiLogsIsError: null,
      };
    case FETCH_APILOGS_IS_PENDING:
      return {
        ...state,
        fetchApiLogsIsCompleted: false,
        fetchApiLogsIsPending: true,
        fetchApiLogsIsError: null,
      };
    case FETCH_APILOGS_IS_ERROR:
      return {
        ...state,
        fetchApiLogsIsCompleted: true,
        fetchApiLogsIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchApiLogsIsError: action.error,
      };
    case FILTER_APILOGS:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        filterBy: action.filter,
      };
    default:
      return state;
  }
};

export default apiLogsReducer;
